<template>
  <div class="container">
    <l-container>
      <ul class="nav">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="currentNavIndex==index?'active':''"
          @click="selectNav(index)"
        >{{item.navName}}</li>
      </ul>
      <router-view />
    </l-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      level: JSON.parse(localStorage.getItem("userinfo"))?.level,
      navList: [],
      list: [
        { navName: "普通用户列表", url: "/userAdmin/userList" },
        { navName: "咨询师列表", url: "/userAdmin/counselorList", level: [2] },
        { navName: "管理员列表", url: "/userAdmin/adminList", level: [2] },
        { navName: "部门管理", url: "/userAdmin/classList" },
      ],
      currentNavIndex: 0,
    };
  },
  methods: {
    //选择导航栏
    selectNav(index) {
      this.currentNavIndex = index;
      this.$router.push(this.navList[this.currentNavIndex].url);
    },
  },
  created() {},
  mounted() {},
  //路由守卫
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.navList = vm.list.filter((item) => {
        if ('level' in item) {
          return item.level.indexOf(vm.level) > -1
        } else {
          return true
        }
      });
      vm.navList.forEach((item, index) => {
        if (item.path == to.path) {
          vm.nav = index;
        }
      });
    });
  },
};
</script>

<style lang="less" scoped>
.container {
  /deep/.el-pagination {
    bottom: 22px;
  }
  .nav {
    display: flex;
    li.active {
      height: 50px;
      line-height: 50px;
      padding: 0 25px 0 27px;
      box-sizing: border-box;
      opacity: 1;
      background: #3170ff;
      border-radius: 25px;
      font-size: 18px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      margin-right: 10px;
    }
    li {
      height: 50px;
      line-height: 50px;
      padding: 0 25px 0 27px;
      box-sizing: border-box;
      opacity: 1;
      border-radius: 25px;
      font-size: 18px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      margin-right: 10px;
    }
  }
}
</style>